import * as React from "react";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
export default function AnodizedAluminumProperties() {
  const specifications = [{
    property: "Material",
    detail: "Anodized aluminum"
  }, {
    property: "Stock gauges/thicknesses",
    detail: "{{verify: gauge/thickness list}}"
  }, {
    property: "Colors/finishes",
    detail: "{{verify: anodized color and finish list}}"
  }, {
    property: "UV stability/outdoor life",
    detail: "{{verify: UV stability / expected outdoor life}}"
  }, {
    property: "Weight vs steel",
    detail: "Lighter than stainless (general aluminum trait)"
  }, {
    property: "Mark method",
    detail: "Laser mark within/under the anodic layer {{verify: mark methods/contrast by finish}}"
  }, {
    property: "Operating temperature",
    detail: "{{verify: temperature guidance}}"
  }, {
    property: "Mounting",
    detail: "{{verify: holes/studs/adhesive options}}"
  }, {
    property: "Serialization/data matrix",
    detail: "{{verify: serialization & 2D data matrix capability}}"
  }];
  return;
}